<template>
  <div class="section-main__warp violation-list-page">
    <div class="header"
         v-if="false">
      <el-button type="primary"
                 size="small"
                 class="iss-operation-button"
                 icon="el-icon-connection"
                 @click="exportData">导出</el-button>
    </div>
    <ioc-table ref="dataTable"
               :data="dataList"
               :option="tableOption"
               :page="page"
               @size-change="handleSizeChange"
               @current-change="handleCurrentChange"
               @selection-change="handleSelectionChange"
               @search-change="search"
               @search-reset="reset">
      <template slot="status"
                slot-scope="scope">
        <span v-if="scope.row.status === '1'"
              style="color: #9b9b9b">{{
          statusFormatter(scope.row)
        }}</span>
        <span v-if="scope.row.status === '2'"
              style="color: yellow">{{
          statusFormatter(scope.row)
        }}</span>
        <span v-if="scope.row.status === '3'"
              style="color: #00e8bb">{{
          statusFormatter(scope.row)
        }}</span>
      </template>
      <template slot="menu"
                slot-scope="scope">
        <el-tooltip class="item"
                    effect="dark"
                    content="修改"
                    placement="top"
                    popper-class="tooltip-draw"
                    v-auth="'/violation/list:update'">
          <el-button type="text"
                     :disabled="scope.row.status !== '2'"
                     icon="iconfont icon-xiugai"
                     @click="handleEdit(scope.row, scope.index)"></el-button>
        </el-tooltip>
      </template>
    </ioc-table>
    <el-dialog title="修改罚单"
               :visible="showDialog"
               v-dialogDrag
               :before-close="closeDialog"
               :close-on-click-modal="false"
               :close-on-press-escape="false">
      <div class="edit-container">
        <el-scrollbar style="height: 100%">
          <el-form ref="form"
                   :model="editForm">
            <el-row>
              <template v-for="(col, index) in tableOption.column">
                <el-col :key="index"
                        v-if="isColumnDisplay(col)"
                        :span="col.span || 12">
                  <el-form-item :prop="col.prop"
                                :label="col.label"
                                :rules="col.rules"
                                label-width="110px">
                    <template>
                      <div v-if="col.formslot">
                        <div v-if="col.prop === 'violationTime'">
                          <el-date-picker style="width: 100%"
                                          placeholder="请选择违规时间"
                                          type="datetime"
                                          v-model="editForm[col.prop]"></el-date-picker>
                        </div>
                        <div v-if="col.prop === 'name'">
                          <choose-person v-model="personInfo"></choose-person>
                        </div>
                      </div>
                      <el-select style="width: 100%"
                                 v-model="editForm[col.prop]"
                                 :disabled="isColumnDisabled(col)"
                                 v-else-if="col.type === 'select'"
                                 :multiple="col.multiple || false"
                                 :filterable="col.filterable">
                        <el-option v-for="item in col.dicData"
                                   :key="item.value"
                                   :label="item.label"
                                   :value="item.value"></el-option>
                      </el-select>
                      <el-date-picker v-else-if="col.type === 'datetime'"
                                      placeholder="选择日期"
                                      type="datetime"
                                      :disabled="isColumnDisabled(col)"
                                      v-model="editForm[col.prop]"
                                      :picker-options="
                          col.pickerDisabled ? col.pickerDisabled : {}
                        "></el-date-picker>
                      <el-input v-else
                                :placeholder="
                          col.searchPlaceholder ||
                          col.placeholder ||
                          `${$t('tip.input')}${col.label}`
                        "
                                v-model="editForm[col.prop]"
                                :disabled="isColumnDisabled(col)"
                                :type="col.type"
                                :maxlength="
                          col.type === 'textarea'
                            ? col.maxlength || 200
                            : col.maxlength
                        "
                                :show-word-limit="col.type === 'textarea'"></el-input>
                    </template>
                  </el-form-item>
                </el-col>
              </template>
            </el-row>
          </el-form>
        </el-scrollbar>
      </div>
      <div slot="footer"
           class="dialog-footer">
        <el-button type="primary"
                   @click="saveForm()">保存</el-button>
        <el-button type="info"
                   @click="closeDialog()">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { api } from "../api";
import utils from '@src/common/utils'
import tableOption from "../option/violation.js";
import ChoosePerson from "../components/choose-person";
export default {
  components: {
    ChoosePerson,
  },
  data () {
    return {
      dataList: [],
      page: {
        currentPage: 1,
        total: 0,
        pageSize: utils.Cache.get('CURRENT_PAGESIZE') || 10,
      },
      tableOption: tableOption(),
      editForm: {},
      personInfo: "",
      showDialog: false,
    };
  },
  watch: {
    personInfo (newVal) {
      this.editForm.name = newVal.split(":")[0].split("-")[0];
      this.editForm.plateCode = newVal.split(":")[0].split("-")[1];
      this.editForm.personnelCode = newVal.split(":")[1].split("-")[0];
      this.editForm.vehicleCode = newVal.split(":")[1].split("-")[1];
      this.editForm.personnelType = newVal.split(":")[2].split("-")[0];
      this.editForm.phone = newVal.split(":")[2].split("-")[1];
    },
  },
  mounted () {
    this.searchForm = {};
    this.getDataList();
  },
  methods: {
    statusFormatter (data) {
      switch (data.status * 1) {
        // 1:待接待人审批,2:接待人审批通过,待部门负责人审批3:部门负责人审批通过,待区域负责人审批4:区域负责人同意5:拒绝'
        case 1:
          return "忽略";
        case 2:
          return "未处理";
        case 3:
          return "已处理";
        default:
          return data.status;
      }
    },
    saveForm () {
      let params = {
        area: this.editForm.area,
        personnelCode: this.editForm.personnelCode,
        plateCode: this.editForm.plateCode,
        status: this.editForm.status,
        violationCode: this.editForm.violationCode,
        violationTime: this.$utils.Dates.dayjs(
          this.editForm.violationTime
        ).format("YYYY-MM-DD HH:mm:ss"),
        vehicleCode: this.editForm.vehicleCode,
      };
      this.$fetch(api.violation.updateViolationRecord, params).then((res) => {
        if (res.success) {
          this.$message.success("罚单修改成功");
          this.closeDialog()
          this.getDataList();
        } else {
          this.$message.error(res.msgContent || "修改罚单记录失败");
        }
      });
    },
    closeDialog () {
      this.$refs.form.resetFields();
      this.showDialog = false;
    },
    isColumnDisplay (col) {
      return col.editDisplay;
    },
    isColumnDisabled (col) {
      return col.editDisabled;
    },
    search (searchForm) {
      this.page.currentPage = 1;
      this.searchForm = searchForm;
      if (
        this.searchForm.violationTime &&
        this.searchForm.violationTime.length
      ) {
        this.searchForm.startTime = this.$utils.Dates.dayjs(
          this.searchForm.violationTime[0]
        ).format("YYYY-MM-DD HH:mm:ss");
        this.searchForm.endTime = this.$utils.Dates.dayjs(
          this.searchForm.violationTime[1]
        ).format("YYYY-MM-DD HH:mm:ss");
      }
      delete this.searchForm.violationTime;
      this.getDataList();
    },
    reset (searchForm = {}) {
      this.page.currentPage = 1;
      this.searchForm = searchForm;
      this.getDataList();
    },
    handleEdit (row) {
      this.editForm = { ...row };
      this.personInfo =
        this.editForm.name +
        "-" +
        (this.editForm.plateCode || "") +
        ":" +
        this.editForm.personnelCode +
        "-" +
        (this.editForm.vehicleCode || "") +
        ":" +
        this.editForm.personnelType +
        "-" +
        (this.editForm.phone || "");
      this.showDialog = true;
    },
    reloadData () {
      this.page.currentPage = 1;
      this.getDataList();
    },
    exportData () { },
    handleSizeChange (pageSize) {
      this.page.pageSize = pageSize;
      this.reloadData();
    },
    handleCurrentChange (currentPage) {
      this.page.currentPage = currentPage;
      this.getDataList();
    },
    handleSelectionChange () { },
    getDataList () {
      const params = {
        templateCode: this.templateCode,
        pageNum: this.page.currentPage,
        pageSize: this.page.pageSize,
        ...this.searchForm,
      };
      const loading = this.$loading({
        lock: true,
        text: '请求中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      this.$fetch(api.violation.queryViolationRecordList, params).then(
        (res) => {
          setTimeout(() => {
            loading.close()
          }, 500);
          if (res.success) {
            this.dataList = res.returnObj.list;
            this.page.total = res.returnObj.total;
          } else {
            this.$message.error(res.msgContent || "查询罚单记录失败");
          }
        }
      );
    },
  },
};
</script>

<style lang="scss">
.violation-list-page {
  .edit-container {
    height: 220px;
    overflow: hidden;
  }
}
</style>